/* Aurolis 3+1 cart status. Uses cart line variant titles and marked gift properties, so it needs no full-catalog download. */
(function () {
  if (window.__AUROLIS_3PLUS1_PICKER_LOADED) return;
  window.__AUROLIS_3PLUS1_PICKER_LOADED = true;

  const GIFT_PROPERTY = "_Aurolis 3+1 Geschenk";
  const GIFT_PROPERTY_VALUE = "Ja";
  let syncing = false;
  let syncAgain = false;
  let debounceTimer = null;
  let isRefreshingThemeCart = false;
  let buyVariantIds = new Set();
  let giftVariantIds = new Set();
  let catalogReady = false;

  const getWidgets = () => Array.from(document.querySelectorAll("[data-aurolis-gift-picker]"));
  const getRoutes = () => {
    const root = getWidgets()[0];
    return root ? {
      cartJson: root.dataset.cartJsonUrl,
      cartChange: root.dataset.cartChangeUrl,
      buyProductsUrl: root.dataset.buyProductsUrl,
      giftProductsUrl: root.dataset.giftProductsUrl
    } : null;
  };
  const variantTitle = item => String(item && item.variant_title || "").trim();
  const variantId = item => String(item && (item.variant_id || item.id) || "");
  const isBuyItem = item => variantTitle(item) === "50 ml Spray" && buyVariantIds.has(variantId(item));
  const isGiftItem = item => variantTitle(item) === "30 ml Spray" && giftVariantIds.has(variantId(item));
  const isMarkedGift = item => Boolean(item && item.properties &&
    item.properties[GIFT_PROPERTY] === GIFT_PROPERTY_VALUE && isGiftItem(item));
  const buyCount = cart => (cart.items || []).reduce(
    (total, item) => total + (isBuyItem(item) ? Number(item.quantity || 0) : 0), 0
  );
  const giftCount = cart => (cart.items || []).reduce(
    (total, item) => total + (isGiftItem(item) ? Number(item.quantity || 0) : 0), 0
  );
  // Only gifts selected through the dedicated picker count as a completed selection.
  // An unmarked 30 ml item may have been added manually and must not hide the selection link.
  const markedGiftCount = cart => (cart.items || []).reduce(
    (total, item) => total + (isMarkedGift(item) ? Number(item.quantity || 0) : 0), 0
  );
  const signatureFor = cart => (cart.items || []).map(item => [
    String(item.variant_id || item.id || ""),
    variantTitle(item),
    Number(item.quantity || 0),
    isMarkedGift(item) ? "gift" : "regular",
    item.key || ""
  ].join(":")).join("|");

  const requestJson = async (url, options) => {
    const response = await fetch(url, Object.assign({
      credentials: "same-origin",
      headers: { "Accept": "application/json" }
    }, options || {}));
    const data = await response.json();
    if (!response.ok || data.errors) {
      const detail = typeof data.description === "string" ? data.description :
        (typeof data.errors === "string" ? data.errors : "Die Warenkorbänderung konnte nicht gespeichert werden.");
      throw new Error(detail);
    }
    return data;
  };
  const readCart = routes => requestJson(routes.cartJson, { method: "GET" });

  function setWidgetState(widget, state) {
    ["progress", "choose", "added", "error"].forEach(name => {
      const node = widget.querySelector('[data-aurolis-state="' + name + '"]');
      if (node) node.hidden = name !== state;
    });
  }

  function renderWidget(widget, cart, signature) {
    if (widget.dataset.cartSignature === signature) return;
    widget.dataset.cartSignature = signature;

    const buys = buyCount(cart);
    const gifts = markedGiftCount(cart);
    const earned = Math.floor(buys / 3);
    const hasMarkedGift = (cart.items || []).some(isMarkedGift);
    widget.hidden = !(buys > 0 || hasMarkedGift);
    if (widget.hidden) return;

    const progressText = widget.querySelector("[data-aurolis-progress-text]");
    const progressFill = widget.querySelector("[data-aurolis-progress-fill]");
    if (buys < 3) {
      setWidgetState(widget, "progress");
      if (progressText) {
        const remaining = 3 - buys;
        progressText.textContent = "Noch " + remaining +
          " teilnehmende 50-ml-Duft" + (remaining === 1 ? "" : "e") +
          " bis zu deinem Gratisduft.";
      }
      if (progressFill) progressFill.style.width = Math.min(100, buys / 3 * 100) + "%";
      return;
    }

    if (gifts >= earned) {
      setWidgetState(widget, "added");
      const addedText = widget.querySelector("[data-aurolis-added-text]");
      if (addedText) {
        if (gifts > earned) {
          addedText.textContent = "Du hast " + gifts + " teilnehmende 30-ml-Düfte im Warenkorb. " +
            earned + (earned === 1 ? " davon erhält den Gratisrabatt; weitere Düfte bleiben regulär berechnet." :
            " davon erhalten den Gratisrabatt; weitere Düfte bleiben regulär berechnet.");
        } else {
          addedText.textContent = earned > 1
            ? "Deine Gratisdüfte sind im Warenkorb. Der Rabatt wird automatisch berechnet."
            : "Dein 30-ml-Gratisduft ist im Warenkorb. Der Rabatt wird automatisch berechnet.";
        }
      }
      return;
    }

    setWidgetState(widget, "choose");
    const remainingGifts = earned - gifts;
    const chooseText = widget.querySelector("[data-aurolis-choose-text]");
    if (chooseText) {
      chooseText.textContent = "Du hast Anspruch auf " + earned +
        (earned === 1 ? " Gratisduft." : " Gratisdüfte.") +
        " Bereits im Warenkorb: " + gifts + " von " + earned + ". " +
        "Wähle die restlichen " + remainingGifts +
        (remainingGifts === 1 ? " Gratisduft" : " Gratisdüfte") +
        " auf der nächsten Seite aus.";
    }
    const linkLabel = widget.querySelector("[data-aurolis-link-label]");
    if (linkLabel) linkLabel.textContent = remainingGifts > 1
      ? remainingGifts + " Gratisdüfte gemeinsam auswählen"
      : "Gratisduft auswählen";
  }

  async function reconcileMarkedGifts(cart, routes) {
    const earned = Math.floor(buyCount(cart) / 3);
    const cartLines = cart.items || [];
    // Do not count manually added 30 ml variants as a completed selection.
    // The gift-finder replaces the current unmarked item when the customer chooses.
    const allowedMarkedQty = earned;
    const lines = cartLines.filter(isMarkedGift).slice().reverse();
    let excess = lines.reduce((total, item) => total + Number(item.quantity || 0), 0) - allowedMarkedQty;
    if (excess <= 0) return { cart, changed: false };

    for (const item of lines) {
      if (excess <= 0) break;
      const quantity = Number(item.quantity || 0);
      const removeQty = Math.min(quantity, excess);
      await requestJson(routes.cartChange + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: item.key, quantity: quantity - removeQty })
      });
      excess -= removeQty;
    }
    return { cart: await readCart(routes), changed: true };
  }

  async function refreshThemeCart() {
    if (isRefreshingThemeCart) return;
    isRefreshingThemeCart = true;
    try {
      const pageCart = document.querySelector("cart-items");
      if (pageCart && typeof pageCart.onCartUpdate === "function") await pageCart.onCartUpdate();
      const drawerCart = document.querySelector("cart-drawer-items");
      if (drawerCart && typeof drawerCart.onCartUpdate === "function") await drawerCart.onCartUpdate();
    } catch (error) {
      console.warn("[Aurolis 3+1] Cart sections refresh failed:", error);
    } finally {
      isRefreshingThemeCart = false;
    }
  }

  function renderFixedGiftQuantities(cart) {
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    const quantityInputs = Array.from(document.querySelectorAll("[data-quantity-line-key]"));
    items.forEach((item) => {
      if (!isMarkedGift(item)) return;
      const key = String(item.key || "");
      const input = quantityInputs.find((node) => String(node.dataset.quantityLineKey || "") === key);
      if (!input) return;
      const row = input.closest("tr") || input.closest(".cart-item");
      if (!row) return;
      const controls = row.querySelector(".quantity-popover-container");
      if (controls) {
        controls.classList.add("aurolis-fixed-gift-quantity-controls");
        controls.style.setProperty("display", "none", "important");
      }
      const wrapper = row.querySelector(".cart-item__quantity-wrapper");
      const removeButton = wrapper && wrapper.querySelector("cart-remove-button");
      if (!wrapper || !removeButton) return;
      let counter = wrapper.querySelector(".aurolis-fixed-gift-quantity");
      if (!counter) {
        counter = document.createElement("span");
        counter.className = "aurolis-fixed-gift-quantity";
        counter.setAttribute("aria-live", "polite");
        wrapper.insertBefore(counter, removeButton);
      }
      const quantityText = String(Number(item.quantity || 0));
      const productLabel = String(item.product_title || item.title || "Gratisduft");
      if (counter.textContent !== quantityText) counter.textContent = quantityText;
      counter.setAttribute("aria-label", "Menge " + productLabel + ": " + quantityText);
      counter.dataset.aurolisGiftLineKey = key;
    });
  }

  async function syncAll() {
    if (syncing) {
      syncAgain = true;
      return;
    }
    const routes = getRoutes();
    if (!routes || !catalogReady) return;
    syncing = true;
    try {
      let cart = await readCart(routes);
      const reconciled = await reconcileMarkedGifts(cart, routes);
      cart = reconciled.cart;
      if (reconciled.changed) await refreshThemeCart();
      renderFixedGiftQuantities(cart);
      const signature = signatureFor(cart);
      getWidgets().forEach(widget => renderWidget(widget, cart, signature));
    } catch (error) {
      console.warn("[Aurolis 3+1] Picker sync failed:", error);
    } finally {
      syncing = false;
      if (syncAgain) {
        syncAgain = false;
        window.setTimeout(syncAll, 250);
      }
    }
  }

  function scheduleSync() {
    if (isRefreshingThemeCart) return;
    window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(syncAll, 350);
  }

  let startupAttempted = false;
  let startupInProgress = false;
  async function start() {
    if (startupAttempted || startupInProgress || catalogReady || !getWidgets().length) return;
    const routes = getRoutes();
    if (!routes) return;
    startupAttempted = true;
    startupInProgress = true;
    try {
      if (!window.AurolisPromoData) throw new Error("Die Aktionsliste ist nicht verfügbar.");
      const data = await window.AurolisPromoData.load(routes.buyProductsUrl, routes.giftProductsUrl);
      buyVariantIds = new Set((data.buyVariantIds || []).map(String));
      giftVariantIds = new Set((data.giftVariants || []).map(item => String(item.id)));
      if (!buyVariantIds.size || !giftVariantIds.size) throw new Error("Die Aktionsliste ist leer.");
      catalogReady = true;
    } catch (error) {
      console.warn("[Aurolis 3+1] Eligibility catalog failed:", error);
      getWidgets().forEach(widget => {
        widget.hidden = false;
        setWidgetState(widget, "error");
        const node = widget.querySelector('[data-aurolis-state="error"]');
        const message = node && node.querySelector("[data-aurolis-error-text]");
        if (message) message.textContent = "Deine Gratisduft-Auswahl konnte nicht geprüft werden. Bitte lade den Warenkorb erneut.";
      });
      return;
    } finally {
      startupInProgress = false;
    }
    syncAll();
    document.addEventListener("visibilitychange", () => {
      if (!document.hidden) scheduleSync();
    });
  }

  // Shopify may replace/inject cart-drawer HTML after DOMContentLoaded. Initialize on first appearance.
  const pickerObserver = new MutationObserver(() => {
    if (!startupAttempted && getWidgets().length) {
      start();
    } else if (catalogReady) {
      scheduleSync();
    }
  });
  pickerObserver.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();